import { TagColor } from '@billy/design-system'

import { InvoiceStatus } from '../enums/invoiceStatus'

export const invoiceStatusToTagColor: Record<InvoiceStatus, TagColor> = {
  [InvoiceStatus.All]: 'neutral',
  [InvoiceStatus.Credited]: 'green',
  [InvoiceStatus.Draft]: 'blue',
  [InvoiceStatus.Overdue]: 'red',
  [InvoiceStatus.Paid]: 'green',
  [InvoiceStatus.PartiallyCredited]: 'yellow',
  [InvoiceStatus.PartiallyPaid]: 'yellow',
  [InvoiceStatus.Unpaid]: 'yellow',
}
